module.exports = __webpack_public_path__ + "tg.e44ec0ee5f9dacfb2e04.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tg.svg
// module chunks = styles